module.exports = __webpack_public_path__ + "static/media/fortalezas_logo.8ef3e08b.png";